import { useQuery } from "react-query"
import customAxios from "../utils/customAxios"

const axios = customAxios()

const fetchGetUserinfo = ({ queryKey }: any) => {
  const username = queryKey[1]
  return axios.get(`/users/user_info?username=${username}`)
}

export const useGetUserinfo = (username: string) => {
  return useQuery(["getUserinfo", username], fetchGetUserinfo, {
    staleTime: 100000,
    select,
    onError,
    refetchOnWindowFocus: false,
    enabled: false,
  })
}

const select = (res: any) => {
  return res.data
}

const onError = () => {}
